// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-j_hn","advertDetailHeaderPrice__value":"c-j_ho","advertDetailHeaderPrice__label":"c-j_hp"};